export default __webpack_public_path__ + "static/media/Super_Marka_2021.48fbf711.png";